import FormCreator from './FormCreator';
import FormCreatorModal from './FormCreatorModal';

export { FormCreator, FormCreatorModal };
export default FormCreatorModal;
